import dayjs from "dayjs";

import { analytics } from "~/analytics";
import type { Devo } from "~/hooks/usePlayerStore";

export const PROGRESS_EVENT_NAME = "Audio Playback: Progress";

// Replacement for deprecated segment-based helper. Uses provider-agnostic analytics facade.
export function trackDevoAudioEvent(
  eventTitle: string,
  data: {
    devo?: Devo;
    progress?: number;
    duration?: number;
    percentage?: number;
  } & Record<string, any>,
): void {
  const { devo, progress, duration, percentage, ...extra } = data;
  if (!devo) return;
  const computed = Math.floor((percentage ?? (duration === 0 ? 0 : ((progress ?? 0) / (duration ?? 0)) * 100)) || 0);
  const clamped = Math.max(0, Math.min(100, Number.isFinite(computed) ? computed : 0));
  analytics.track({
    event: eventTitle,
    properties: {
      contentId: devo.id,
      contentDate: devo.date,
      contentTags: devo.tags,
      contentTitle: devo.title,
      contentSubtitle: devo.subtitle,
      contentDayOfWeek: devo.date ? dayjs(devo.date).format("dddd") : undefined,
      percentage: clamped,
      progress,
      duration,
      ...extra,
    },
  });
}

const isBrowser = typeof window !== "undefined";

export function inferSourceFromPathname(pathname?: string): "home" | "search" | "favorites" | "series" | undefined {
  const p = pathname || (isBrowser ? window.location.pathname : "");
  if (p.startsWith("/search")) return "search";
  if (p.startsWith("/settings/favorites")) return "favorites";
  if (p.startsWith("/series")) return "series";
  if (p === "/") return "home";
  return undefined;
}

export function getDeviceType(): "web" | "mobile-web" {
  if (!isBrowser) return "web";

  // Check if mobile based on user agent
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  // Check if mobile based on screen width
  const isMobileScreen = window.innerWidth <= 768;

  return isMobileUA || isMobileScreen ? "mobile-web" : "web";
}

export type UpsellInteractionDetails = {
  episode?: { id: string; name: string };
  series?: { id: string; name: string };
  sourceComponent: string;
};
export function trackUpsellInteraction(options: UpsellInteractionDetails) {
  return analytics.track({ event: "Upsell Interaction", properties: options });
}
